import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';
import { Typography } from '@/components/Typography';

import { Accordion } from '../Accordion';
export const Wrapper = styled(Flex)`
  flex-direction: column;
  ${({ theme }) => css`
    max-width: ${theme.breakpoints.lg};
    margin: 0 auto;
  `}
`;
export const HeadingBox = styled(Flex)`
  ${({ theme }) => css`
    margin-bottom: ${theme.spacing(1.25)};
    width: 100%;
    justify-content: center;
  `}
`;

export const CaliberTabs = styled.ul`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    justify-content: center;
    list-style: none;
    padding: ${theme.spacing(0, 1.5)};
    margin: 0 auto;
    z-index: 1;
  `}
`;
export const CaliberTabBox = styled.li<{ $active?: boolean }>`
  ${({ theme }) => css`
    padding: ${theme.spacing(2, 5, 1.25)};
    background-color: ${theme.colors.mediumGrey};
    margin-left: ${theme.spacing(1)};
    font-family: ${theme.fontFamilies.italianPlate};
  `}
  ${({ $active, theme }) =>
    $active &&
    css`
      background-color: ${theme.colors.primaryBlue};
      a {
        color: ${theme.colors.primary};
      }
    `}
`;
export const CaliberTab = styled.a`
  ${({ theme }) => css`
    font-size: ${theme.spacing(3)};
    cursor: pointer;
    line-height: ${theme.lineHeights.h4};
    text-transform: uppercase;
    color: ${theme.colors.black};
    &:hover {
      color: ${theme.colors.primary};
    }
  `}
`;
export const CaliberContainer = styled(Box)<{ $withTab?: boolean }>`
  padding-top: 0;
  ${({ theme }) => css`
    padding: ${theme.spacing(0, 0, 0, 1.25)};
    ${theme.media.md.up} {
      padding: ${theme.spacing(2, 3)};
    }
  `}

  ${({ $withTab, theme }) =>
    $withTab &&
    css`
      ${theme.media.md.up} {
        box-shadow: 0 -15px 20px -25px ${theme.colors.black};
      }
    `}
`;

export const SwiperContainer = styled.div`
  position: relative;
  ${({ theme }) =>
    css`
      .next,
      .prev {
        padding: ${theme.spacing(1)};
        svg {
          height: ${theme.spacing(4)};

          path {
            fill: ${theme.colors.black};
          }
        }
      }
      .next {
        right: -${theme.spacing(3.5)};
      }
      .prev {
        left: -${theme.spacing(3.5)};
      }
    `}
`;
export const CaliberItem = styled(Flex)<{ $default?: boolean }>`
  ${({ theme }) => css`
    padding: ${theme.spacing(0, 1.25)};
    ${theme.media.md.up} {
      padding: ${theme.spacing(0, 10)};
    }
    text-align: center;
    line-height: ${theme.lineHeights.p2};
    margin-bottom: ${theme.spacing(3.75)};
    font-size: ${theme.spacing(1.75)};
    font-family: ${theme.fontFamilies.openSans};
    justify-content: center;
  `}
  ${({ $default }) =>
    $default &&
    css`
      letter-spacing: 0;
    `}
`;
export const CaliberTitle = styled(Typography)`
  ${({ theme }) => css`
    text-align: center;
    font-size: ${theme.fontSizes.h2};
    text-transform: uppercase;
    margin-bottom: ${theme.spacing(2)};
    font-weight: ${theme.fontWeights.bold};
    line-height: ${theme.lineHeights.h2};
    font-family: ${theme.fontFamilies.italianPlate};
  `}
`;

export const CaliberAccordionWrapper = styled(Accordion)`
  ${({ theme }) => css`
    margin: ${theme.spacing(0, 1.25, 4)};
    font-size: ${theme.spacing(2)};
    line-height: ${theme.spacing(2)};
    position: relative;
    & > header {
      border: 0;
      border-bottom: 1px solid ${theme.colors.lightGray};
      & > button {
        height: auto;

        border: none;
        border-radius: unset;
        background-color: ${theme.colors.primaryBlue};
        color: ${theme.colors.primary};
        & > svg {
          position: absolute;
          right: ${theme.spacing(1.25)};
        }
        .AccordionItemStyle {
          padding: 0;
          margin-bottom: 0;
        }
      }
    }
    .AccordionBox {
      padding: 0;
    }
  `}
`;

export const CaliberAccordionItem = styled(Flex)<{
  $isOpen?: boolean;
}>`
  align-items: center;
  width: 100%;
  ${({ theme, $isOpen }) => css`
    padding: ${theme.spacing(2, 5, 1.25)};
    line-height: ${theme.lineHeights.h4};
    font-size: ${theme.spacing(3)};
    justify-content: center;
    color: ${theme.colors.primary};
    text-transform: uppercase;
    background-color: ${theme.colors.primaryBlue};
    font-family: ${theme.fontFamilies.italianPlate};
    ${theme.media.md.up} {
      justify-content: center;
    }

    ${$isOpen &&
    css`
      color: ${theme.colors.black};
      background-color: ${theme.colors.mediumGrey};
    `}
  `}
`;
